import { lazy } from 'solid-js'
import { messages } from '../../pages/login-page/login-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/login-page/login-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/login',
    showFooter: false,
    titleMessage: messages.titleMessage,
}
